export default {
      id: "chevron-next-usage",
      viewBox: "0 0 17.785 33.777",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#chevron-next",
      toString: function () {
        return this.url;
      }
    }